import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Moon, Star } from 'lucide-react';
export function Hero() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.5
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 10
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative pt-10 pb-16 px-5 max-w-2xl mx-auto text-center" data-id="element-79">
      {/* Decorative Top */}
      <div className="flex justify-center mb-6" data-id="element-80">
        <motion.div animate={{
        y: [0, -5, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-gold-400 flex gap-2" data-id="element-81">
          <Moon className="w-5 h-5 fill-current" data-id="element-82" />
          <Star className="w-3.5 h-3.5 mt-1 fill-current opacity-70" data-id="element-83" />
        </motion.div>
      </div>

      {/* Headline */}
      <h1 className="font-serif text-[2.6rem] leading-[1.1] sm:text-5xl lg:text-6xl text-gold-400 mb-3" data-id="element-84">
        Stop negotiating at 2am.
      </h1>
      <p className="text-base sm:text-xl text-cream-100 mb-8 font-light px-2 leading-relaxed" data-id="element-85">
        A plug-and-play night system for parents who can't take one more 3am
        argument.
      </p>

      {/* Product Image */}
      <div className="mb-12 relative group" data-id="element-86">
        <div className="absolute -inset-1 bg-gold-400/20 blur-xl rounded-lg opacity-50 group-hover:opacity-75 transition duration-1000" data-id="element-87"></div>
        <img src="https://cdn.magicpatterns.com/uploads/gmFMexWUoM6V5NDxfTTJ4K/heylloyd-image-1771281459603.png" alt="Sleep-Shifts Survival System on iPad" className="relative rounded-lg shadow-2xl w-full border border-white/5" data-id="element-88" />
      </div>

      {/* Opening Lead - Staggered Animation */}
      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-80px'
    }} className="space-y-5 text-base sm:text-lg leading-[1.9] text-cream-50 text-left" data-id="element-89">
        <motion.p variants={item} data-id="element-90">You're not just tired.</motion.p>
        <motion.p variants={item} data-id="element-91">You're doing math in the dark.</motion.p>

        <div className="pl-4 border-l-2 border-gold-400/30 my-6 space-y-3 italic text-cream-100/75 text-sm sm:text-base" data-id="element-92">
          <motion.p variants={item} data-id="element-93">
            If I get up again, I'll be resentful tomorrow.
          </motion.p>
          <motion.p variants={item} data-id="element-94">
            If I wake him, he'll act like I'm dramatic.
          </motion.p>
          <motion.p variants={item} data-id="element-95">
            If I don't wake him, I'll hate him.
          </motion.p>
          <motion.p variants={item} data-id="element-96">
            If I ask for help, I'll have to explain why I deserve it.
          </motion.p>
        </div>

        <motion.p variants={item} data-id="element-97">
          And somehow, in a house with two adults… you still feel like the only
          one ON.
        </motion.p>
        <motion.p variants={item} data-id="element-98">
          The baby wakes up — and instantly it becomes a negotiation.
        </motion.p>
        <motion.p variants={item} data-id="element-99">
          A tone. A look. A sigh. A fight you don't have time for.
        </motion.p>
        <motion.p variants={item} data-id="element-100">
          That's not a "communication problem."
        </motion.p>
        <motion.p variants={item} className="text-gold-400 font-serif text-xl sm:text-2xl pt-3" data-id="element-101">
          That's an undefined system.
        </motion.p>
      </motion.div>
    </section>;
}